module.exports = __webpack_public_path__ + "img/academy-badge-certified-expert.37225c0.svg";